import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';

interface DeletePatternPayload {
  id: number;
}

const useDeleteVendorDetectionPattern = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: DeletePatternPayload) => {
      return (await glynt).vendor.deleteVendorDetectionPattern(id);
    },

    ...callbacks,

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['vendors']
      });
    }
  });
};

export default useDeleteVendorDetectionPattern;
